import { Component, Input } from '@angular/core';
import { OrderExceptionLog } from '../../../overview/models/order-exception';
import { DateTimeFormatPipe } from '../../../orders/components/order-details/pipes/date-time-format.pipe';
import { EllipsisTooltipDirective } from '../../../../directives/ellipsis-tooltip.directive';
import { StripHtmlPipe } from '../../pipes/strip-html.pipe';

@Component({
  selector: 'app-order-exception-logs-table',
  standalone: true,
  templateUrl: './order-exception-logs-table.component.html',
  imports: [DateTimeFormatPipe, EllipsisTooltipDirective, StripHtmlPipe],
  styleUrl: './order-exception-logs-table.component.scss'
})
export class OrderExceptionLogsTableComponent {
  @Input() logs: OrderExceptionLog[] = [];
}
